/** Warm and unhurried: a page somebody is thinking on. */
export const THINKING = ['#6b5ce7', '#d9457c', '#e08a2e', '#3f9a4a', '#2a8fbd'];
/** Yes, no, and the thing that would settle it. */
export const DECISION = ['#3f9a4a', '#d9457c', '#6b7280'];
/** Ink and graphite, with one accent: a plan somebody has to act on. */
export const PLANNING = ['#2f6fb0', '#4a5568', '#3f9a4a', '#e08a2e', '#d9457c'];
/** Cold and technical: systems, and the mornings after they break. */
export const TECHNICAL = ['#0f766e', '#2f6fb0', '#6b5ce7', '#b91c1c', '#4a5568'];
/** Forward motion: a goal, and the steps towards it. */
export const GROWTH = ['#16a34a', '#0891b2', '#7c3aed', '#ea580c', '#ca8a04'];
/** The night sky: planets and the lines between stars. */
export const COSMOS = [
    '#38bdf8',
    '#fbbf24',
    '#f472b6',
    '#34d399',
    '#a78bfa',
    '#fb923c',
];
/** A metro's lines: the blue, green, red and yellow that transit maps are read in. */
export const METRO_SP = ['#0455a1', '#007e5e', '#ee372f', '#fed304'];
//# sourceMappingURL=palettes.js.map